import { CouponResult } from "@/modules/admin/objects/coupon";
import { Facility } from "@/modules/admin/objects/facility";
import { LockSession } from "@/framework/types/LockSession";
import { LocationInfo } from "@/modules/staff/objects/roomConversation";

export default {
  stateOfChatsWithStaff: "",
  displayPromptCompleteService: false,
  checkin: {},
  adminChanged: false,
  adminSubChanged: false,
  currentGroupId: 0,
  botDictUpdatedIdx: 0,
  menuPath: {},
  guestInputData: {},
  facility: {} as Facility,
  selectedMenu: {},
  previousMenu: {},
  tripadvisorDomain: "",
  openHotelMenu: false,
  coupons: [] as CouponResult[],
  lockSession: {} as LockSession,
  tenantId: -1,
  tenantLangCd: "",
  adminTenantFlg: false,
  inputRoomNoBeforeConversation: true,
  tenantInfo: {},
  storeLocationInfo: {} as LocationInfo,
  cmsCouponOption: {},
  stopCheckingImportProcess: false,
  iconColor: "",
};
